const ITEMS = [
  "Learn",
  "Create",
  "Grow",
  "Graphic Design",
  "Photoshop",
  "Video Editing",
  "Posters",
  "Branding",
  "Reels & Shorts",
  "Portfolio",
];

function Track({ ariaHidden }) {
  return (
    <div aria-hidden={ariaHidden || undefined} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={`${item}-${i}`} className="flex items-center">
          <span className="whitespace-nowrap px-6 sm:px-8 font-display text-lg sm:text-2xl font-semibold uppercase tracking-wide text-white/25">
            {item}
          </span>
          <span className="text-amber-500/80 text-xs">✦</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      className="relative border-y border-white/[0.06] bg-obsidian-card/40 py-5 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee">
        <Track />
        <Track ariaHidden />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-obsidian to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-obsidian to-transparent" />
    </div>
  );
}
